import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ScriptLoaderService } from 'helpers/services/script-loader.service';
import { AlertService } from 'pages/authentication/_services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginCustom } from 'pages/authentication/_helpers/login-custom';
import { AuthenticationService } from 'pages/authentication/_services';
import { AlertComponent } from 'pages/authentication/_directives/alert.component';
import { Helpers } from 'helpers';

declare let swal: any;
@Component({
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  model: any = {};
  loading = false;
  tokenFromUrl: string;
  isSubmit: boolean = false;

  @ViewChild('alertForgotPass',
    {read: ViewContainerRef}) alertForgotPass: ViewContainerRef;

  constructor(
    private _router: Router,
    private _script: ScriptLoaderService,
    private _route: ActivatedRoute,
    private _authService: AuthenticationService,
    private _alertService: AlertService,
    private cfr: ComponentFactoryResolver) {
  }

  ngOnInit() {
    this.tokenFromUrl = this._route.snapshot.queryParams['token'];
    this._script.loadScripts('body', [
      'assets/vendors/base/vendors.bundle.js',
      'assets/demo/default/base/scripts.bundle.js'], true).then(() => {
      LoginCustom.init();
    });
  }

  checkConfirmPasswordValidation() {
      if (!this.model.password || !this.model.passwordConformation) {
        return false;
      }
      if (this.model.password === this.model.passwordConformation) {
        return true;
      } else {
        return false;
      }
  }

  resetPassword() {
    this.loading = true;
    this.isSubmit = true;
    if (this.checkConfirmPasswordValidation()) {
      this._authService.passwordReset(this.tokenFromUrl ,this.model).subscribe(
        data => {
          swal({
            type: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 2000
          }).then((result) => {
            this._router.navigate(['/']);
          });
          this.model = {};
          this.loading = false;
          this.isSubmit = false;
        },
        error => {
          this.showAlert('alertForgotPass');
          this._alertService.error(error.message);
          this.loading = false;
          this.isSubmit = false;
        });
    } else {
      this.showAlert('alertForgotPass');
      this._alertService.error('กรุณากรอกข้อมูลยืนยันรหัสผ่านให้ตรงกัน');
      this.loading = false;
    }
  }

  showAlert(target) {
    this[target].clear();
    let factory = this.cfr.resolveComponentFactory(AlertComponent);
    let ref = this[target].createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/templates/reset-password/reset-password.component.ts